import * as yup from 'yup';
import { TFunction } from 'i18next';
import { DateOnly } from '../../utility';
import { IOfferReservationDto } from '../IOfferReservationDto';

export function offerReservationDtoValidation(
  translation: TFunction<'translation', undefined>
): yup.ObjectSchema<IOfferReservationDto> {
  return yup
    .object({
      id: yup.string().required(),

      offerId: yup.string().required(translation('errors.required')),

      acceptedCost: yup.number().required(),
      acceptedDeposit: yup.number().required(),

      contactLanguage: yup.string().oneOf(['de', 'en']).required(),
      contactMail: yup
        .string()
        .email(translation('errors.required'))
        .required(translation('errors.required')),
      contactBirthday: yup
        .date()
        .transform((e) => (e ? new DateOnly(e) : null))
        .typeError(translation('errors.required'))
        .nonNullable(translation('errors.required'))
        .defined(),
      contactPhone: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactTitle: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .nullable()
        .defined(),
      contactFirstname: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactLastname: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactStreet: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactStreetNr: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactPostal: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactCity: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactCountry: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),

      agbAccepted: yup.bool().required().oneOf([true]),
      privacyPolicyAccepted: yup.bool().required().oneOf([true]),
      newsletter: yup.bool().required(),

      tracked: yup.bool().defined(),
      needsDeposit: yup.bool().defined(),

      message: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .nullable()
        .defined(),
    })
    .required();
}
